// apps/web/src/components/auth/useAuth.ts
//
// Thin adapter over the app's canonical auth context (lib/auth.tsx)
// exposing the `{ user, isAuthenticated }` shape the platform
// components expect. The server-verified /me payload lives in the
// `me` state of lib/auth.tsx; this just projects it.

import { useAuth as useAuthContext } from '../../lib/auth.js';
import type { UserMe } from '../../lib/api.js';

export interface UseAuthValue {
  user: UserMe | null;
  isAuthenticated: boolean;
}

export function useAuth(): UseAuthValue {
  const { me } = useAuthContext();
  return {
    user: me.status === 'authenticated' ? me.user : null,
    isAuthenticated: me.status === 'authenticated',
  };
}